import React, { useState } from 'react';
import { useTranslation } from '../i18n';
import closeButton from '../images/close-line-white.svg';
import langIcon from './../images/location-line.svg';
import { analytics } from '../firebaseConfig';
import { logEvent } from 'firebase/analytics';

const ChangeLanguage = () => {
  const { t, changeLanguage } = useTranslation();
  const [langModalIsOpen, setLangIsOpen] = useState(false);
  const [language, setLanguage] = useState(
    localStorage.getItem('language') || 'en',
  );
  function openLangModal() {
    setLangIsOpen(true);
  }
  function closeLangModal() {
    setLangIsOpen(false);
  }

  const handleUpdateLanguage = (lang) => {
    changeLanguage(lang);
    setLanguage(lang);
    logEvent(analytics, 'account_settings_language', { language: lang });
    closeLangModal();
  };

  return [
    <div className="row-item" key="item-row">
      <img height={24} width={24} alt="Change language" src={langIcon} />
      <div
        className="link"
        onClick={() => openLangModal()}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            openLangModal();
          }
        }}
        tabIndex={0}
      >
        {t.changelanguage}
      </div>
      <div className="pt-65 fs-s flex-grow align-right">
        {language === 'en' ? t.english : t.swedish}
      </div>
    </div>,
    langModalIsOpen && (
      <div className="overlay" key="overlay">
        <div className="buttons-wrapper">
          <div className="buttons-header">
            <span>{t.changelanguage}</span>
            <button className="btn-icon" onClick={closeLangModal}>
              <img
                className="icon"
                src={closeButton}
                width={24}
                height={24}
                alt="Close icon"
              />
            </button>
          </div>
          <div className="separator"></div>
          <div className="buttons">
            <button
              className="btn btn-secondary"
              onClick={() => handleUpdateLanguage('en')}
            >
              {t.english}
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => handleUpdateLanguage('sv')}
            >
              {t.swedish}
            </button>
          </div>
        </div>
      </div>
    ),
  ];
};

export default ChangeLanguage;
